export default __webpack_public_path__ + "static/media/ArticleImg.252d1fef.png";